import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {FormattedMessage} from 'react-intl';

import {IStore} from 'redux/interface';
import {
  getTrainingDialogue,
  getTranslations,
  trainingsAsyncActions
} from 'redux/pageAsyncActions';
import {useGetTranslations} from 'utils/hooks/useGetTranslations';
import {BotType} from 'utils/hooks/use-chat-bot/interfaces';
import {TranslationKeys} from 'utils/constants/routeConstants';

import BotChat from 'components/bot-chat';
import {closeArticle} from 'redux/content/actions';
import {ReactComponent as XpeditionIcon} from 'assets/image/menu-auth/DISCOVERY_GABI1.svg';
import {Link, useParams} from 'react-router-dom';

import './styles.scss';
import {BotMode} from '@wholesalechange/chatcomponent';

export const TrainingChat: React.FunctionComponent = () => {
  const {
    loading
  } = useSelector((state: IStore) => state.status);
  const {
    trainingDialogue
  } = useSelector((state: IStore) => state.trainings);
  const {
    settings
  } = useSelector((state: IStore) => state.auth);
  const dispatch = useDispatch();
  const {dialogueId} = useParams();

  useEffect(() => {
    dispatch(closeArticle());
  }, []);

  useEffect(() => {
    if (dialogueId) {
      dispatch(trainingsAsyncActions[getTrainingDialogue](Number(dialogueId)));
    }
  }, [dialogueId]);

  useGetTranslations({
    translationKey: TranslationKeys.Chat
  });

  function renderBreadcrumbs() {
    return (
      <div className="breadcrumbs">
        <Link className="breadcrumbs__previous" to="/trainings">
          <FormattedMessage
            id={'gritx.trainings.breadcrumb.previous'}
            defaultMessage="Trainings"
          />
        </Link>
        {trainingDialogue && (
          <span className="training__title-dialogue-name">
            {' '} - {trainingDialogue.dialogName}
          </span>
        )}
      </div>
    );
  }

  return (
    <div className="training">
      {
        !loading.includes(getTranslations) && trainingDialogue && <>
          <h1 className="training__title">
            <XpeditionIcon className="training__icon"/>
            {renderBreadcrumbs()}
          </h1>
          <BotChat
            chatType={BotType.Xpedition} chatMode={BotMode.NoHistory}
            dialogueId={trainingDialogue.dialogId}
            title={trainingDialogue.dialogName}
            tabsEnabled={settings?.chatSettings?.tabsEnabled || false}
          />
        </>
      }
    </div>
  );
};
